import { ChecksRegisterModal, ConfirmMail, ConsentTermsRegisterModal, PassValidation, RegistroUser, UiModal } from "libs/raas-ui-react-components/src/components"
import { useState } from "react"
import { useNavigate } from "react-router-dom";
import { postAxios } from "services/api/api.service";
import { apiNames } from "services/api/endpoint.service";
import { setStorage } from "services/user/user.session.service";
import useSession from "hooks/useSession";
import useToast from "hooks/useToast";
import { openMail, resendMail } from "./RegisterUserATC.service";
import { confirmMailLiterals, getChecksRegisterModalLiterals, getLiteralsRegistroPage, passValidationLiterals, registerUserLiterals } from "./RegisterUserFlowATC.util";
import { useTranslation } from "react-i18next";


export const RegisterUserFlowATC = () => {

  const navigate = useNavigate();
  const [t/*, i18n*/] = useTranslation("registerflow");

  const { setSession, setLogged } = useSession();
  const { openToast } = useToast();
  const [step, setStep] = useState(0);
  const [registerToken, setRT] = useState("");
  const [validationToken, setVT] = useState("");
  const [email, setEmail] = useState("");

  /**** Literales por pagina ****/
  const literalsRegistroPage = getLiteralsRegistroPage(t);

  /**** Fin Literales por pagina ****/

  /**** Lógica consentimientos ****/
  const conditionsModalLiterals = getChecksRegisterModalLiterals(t);
  const [showChecksModal, setShowChecksModal] = useState(true);
  const [checksStatus, setChecksStatus] = useState({
    checks: {
      "termsAndPolicy": { value: false, required: true },
      "age": { value: false, required: true },
      "comercial-communications": { value: false, required: false },
      "personal-data-sharing": { value: false, required: false },
      "profile-custom-experience": { value: false, required: false }
    },
    allChecked: false,
    valid: false
  });
  /**** Fin lógica consentimientos ****/


  const handleChangeMail = () => {
    setStep(0)
  }

  const handleBackStep = (step: number) => {
    setStep(step - 1);
  }

  const handleRegisterContinueButton = (email: string) => {
    let body = {
      "email": email,
      "privacy-options": {
        "comercial-communications": checksStatus.checks['comercial-communications'].value,
        "personal-data-sharing": checksStatus.checks['personal-data-sharing'].value,
        "profile-custom-experience": false//checksStatus.checks['profile-custom-experience'].value
      },
      "created-by-agent": true
    };
    postAxios(apiNames.IDENTITY, false, "/customers/email-creation", body).then((response: any) => {
      openToast("success", literalsRegistroPage.toast.success.title, `${literalsRegistroPage.toast.success.desc} ${email}`)
      setRT(response?.data?.token);
      setStep(1);
    }).catch((error) => {
      if (error?.status == 409) {
        openToast("error", literalsRegistroPage.toast.errorExists.title, literalsRegistroPage.toast.errorExists.desc);
      } else if (Math.floor(error?.status / 100) === 4) {
        openToast("error", literalsRegistroPage.toast.errorTryLater.title, literalsRegistroPage.toast.errorTryLater.desc);
      }
    })
  }

  const handleNextPage = (data: any) => {
    const _email = data.detail;
    setEmail(_email);
    if (checksStatus.valid) {
      handleRegisterContinueButton(_email);
    } else {
      setShowChecksModal(true);
    }
  }

  const handleReSendEmail = () => {
    resendMail(email, openToast, t)
  }

  const handleVerifyEmail = (data: any) => {
    let body = {
      token: registerToken,
      code: data?.detail
    };
    postAxios(apiNames.IDENTITY, false, "/customers/email-verification", body).then((response: any) => {
      setVT(response?.data?.token);
      setStep(2);
    }).catch((error) => {
      if (Math.floor(error?.status / 100) === 4) {
        openToast("error", t('literals.registroPage.toast.errorEmailVerify.title'), t('literals.registroPage.toast.errorEmailVerify.desc'));
      }
    })
  }

  const handleConfirmPass = (data: any) => {
    let password = data.detail
    if (password) {
      let body = {
        token: validationToken,
        password
      };
      postAxios(apiNames.IDENTITY, false, "/customers/account-creation", body).then((response: any) => {

        // LOGIN
        setSession(response?.data);
        setStorage(response?.data);
        setLogged(true);

        navigate("/on-boarding-ATC");
      }).catch((error) => {
        if (Math.floor(error?.status / 100) === 4) {
          openToast("error", t('literals.registroPage.toast.errorTryLater.title'), t('literals.registroPage.toast.errorTryLater.desc'));
        }
      })
    }
  }

  const handleOpenMail = () => {
    openMail(email);
  }

  const handleExit = () => {
    navigate(-1);
  }

  const getEnvinmentRecaptcha = (): string => {
    const host = window.location.host;
    const regex = /^(www){1}(\.\w+){0,1}(\.docomobility\.com){1}$/i;
    const match = host.match(regex);

    let sitekey: any = '';
    // entorno dev
    if (host.includes("local")) {
      sitekey = process.env.REACT_APP_RECAPTCHA_INT;
    }
    // Si es un entorno de desarrollo o de pruebas, que no sea de producción.
    else if (match && match[2]?.length > 0) {
      sitekey = process.env.REACT_APP_RECAPTCHA_INT;
    }
    else if (match && match[2] === undefined) {
      sitekey = process.env.REACT_APP_RECAPTCHA_PRO;
    }
    // prod
    return sitekey;
  }

  const apikey: string = getEnvinmentRecaptcha();


  const getStepComponent = (s: number) => {
    switch (s) {
      case 0:
        return <RegistroUser
          literals={literalsRegistroPage}
          mail={email}
          onExitPage={handleExit}
          onBackPage={handleExit}
          onNextPage={handleNextPage}
          sitekey={apikey} />;
      case 1:
        return <ConfirmMail
          literals={confirmMailLiterals(t)}
          // recover-password={true}
          create-user={true}
          onOpenMail={handleOpenMail}
          mail={email}
          onExitPage={handleExit}
          onResendMail={handleReSendEmail}
          onChangeMail={handleChangeMail}
          onVerifyEmail={handleVerifyEmail}
          onBackPage={() => handleBackStep(1)} />;
      case 2:
        return <PassValidation
          literals={passValidationLiterals(t)}
          onExitPage={handleExit}
          onConfirmPass={handleConfirmPass} />;
      default:
        <RegistroUser
          literals={registerUserLiterals(t)}
          mail={email}
          onExitPage={handleExit}
          onNextPage={handleNextPage}
          sitekey={`${apikey}`} />;
    }
  }

  /**** Lógica consentimientos ****/
  /**
   * @description Guarda los valores de los checks en todo momento.
   * @param {CustomEvent} e Evento   
   */
  const checkChangedHandler = (e: CustomEvent) => {
    setChecksStatus(e.detail);
  }
  /**
   * @description Cierra la modal con el aspa
   */
  const closeModalHandler = () => {
    setShowChecksModal(false);
    navigate('/'); // tiene que volver.
  }
  /**
   * @description Captura los clicks de los botones inferiores de la modal.
   * @param {CustomEvent} e Evento del click de los botones inferiores.
   */
  const buttonsFooterClickHandler = (e: CustomEvent) => {
    /* Botón Cancelar */
    if (e.detail === 'cancel') {
      setShowChecksModal(false);
      navigate('/'); // tiene que volver.
    }
    /* Botón Continuar */
    else {
      /* Los checks mínimos requeridos deben ser aceptados para continuar */
      if (checksStatus.valid) {
        setShowChecksModal(false);
        if (!!email) {
          handleRegisterContinueButton(email);
        }
      }
      else {
        setShowChecksModal(true);
      }
    }
  }
  /**** Fin lógica consentimientos ****/

  return (
    <>
      {getStepComponent(step)}

      <UiModal open={showChecksModal} blockOverlay={true}>
        <ChecksRegisterModal
          literals={conditionsModalLiterals}
          onCheckChanged={checkChangedHandler}
          onCloseModal={closeModalHandler}
          onButtonsFooterClick={buttonsFooterClickHandler}
        />
      </UiModal>
    </>
  )
}
